const withinBounds = (max: number, min: number = 0) => (value: number) =>
    value < min ? min : value > max ? max : value

export default withinBounds
